// ABOUTME: Tells the page beside the docked cart whether the cart panel is open, so the page can
// ABOUTME: make room for it; false wherever the cart is not docked (the modal drawer covers the page).

import { createContext } from 'react';

export const CartDockContext = createContext(false);
